// Cart functionality - vanilla JS with fetch
function serializeFormToBody() {
  const ticketInfo = document.getElementById('ticket-information');
  if (!ticketInfo) return '';
  const fd = new FormData();
  ticketInfo.querySelectorAll('input, select').forEach((el) => {
    if (!el.name) return;
    if (el.type === 'checkbox' || el.type === 'radio') {
      if (el.checked) fd.append(el.name, el.value);
    } else {
      fd.append(el.name, el.value);
    }
  });
  return new URLSearchParams(fd).toString();
}

function isEmptyObject(obj) {
  return obj && Object.keys(obj).length === 0;
}

function showPlaceOrderProcessingWarning(form) {
  if (!form || document.getElementById('order-processing')) return;

  form.querySelectorAll('input[type=submit]').forEach((btn) => {
    btn.disabled = true;
    const parent = btn.closest('.formfield');
    if (parent) parent.style.display = 'none';
  });

  const msg = document.createElement('div');
  msg.id = 'order-processing';
  msg.className = 'flash';
  msg.innerHTML = `<div class="information"><p>Your order is being processed. <strong>Please do not hit the back button, reload the page, or resubmit your order.</strong> Doing so may result in your card being charged multiple times. This page will refresh when your order is complete.</p></div>`;
  form.appendChild(msg);
}

function bindPlaceOrderProcessingWarning(cart) {
  if (!cart.classList.contains('review')) return;

  const form = cart.querySelector('form');
  if (!form) return;

  form.addEventListener('submit', () => showPlaceOrderProcessingWarning(form));
}

export function initCart() {
  const cart = document.getElementById('cart');
  if (!cart) return;

  bindPlaceOrderProcessingWarning(cart);

  const orderForm = document.getElementById('order_form');
  const ticketInfo = document.getElementById('ticket-information');
  const itemsInCart = document.getElementById('items-in-cart');
  if (!orderForm || !ticketInfo || !itemsInCart) return;

  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

  function removePackage(e) {
    e.preventDefault();
    if (!confirm('Are you sure you want to remove these tickets from your cart?')) return;

    const row = e.target.closest('tr');
    row.style.transition = 'opacity 0.4s';
    row.style.opacity = '0';

    setTimeout(() => {
      row.querySelectorAll('td.upgrade select, td.quantity select, td.quantity input').forEach((el) => (el.value = 0));

      fetch(orderForm.action, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRF-Token': csrfToken,
          Accept: 'application/json',
        },
        body: serializeFormToBody(),
      })
        .then((r) => r.json())
        .then((data) => {
          if (data.redirect) {
            window.location = data.redirect;
            return;
          }
          if (!data.line_items || isEmptyObject(data.line_items)) {
            window.location = '/tickets';
          } else {
            itemsInCart.innerHTML = data.html;
            const cartLink = document.querySelector('.widget.account li.cart a');
            if (cartLink) cartLink.textContent = `View my cart (${data.quantity_in_cart})`;
            if (data.errors && !isEmptyObject(data.errors)) {
              const errDiv = document.createElement('div');
              errDiv.innerHTML = data.errors;
              const toInsert = errDiv.firstElementChild || errDiv;
              ticketInfo.parentNode.insertBefore(toInsert, ticketInfo);
            }
            reattachCartListeners();
          }
        });
    }, 400);
  }

  function addPackageToCart(e) {
    if (e) e.preventDefault();

    const addOnRow = e.target.closest('.add_on');
    const qtySelect = addOnRow?.querySelector('select[name*="quantity"]');
    if (!qtySelect || qtySelect.value === '0') return;

    const form = addOnRow.closest('form');
    addOnRow.style.transition = 'opacity 0.4s';
    addOnRow.style.opacity = '0';

    setTimeout(() => {
      fetch(form.action, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRF-Token': csrfToken,
          Accept: 'application/json',
        },
        body: serializeFormToBody(),
      })
        .then((r) => r.json())
        .then((data) => {
          if (data.redirect) {
            window.location = data.redirect;
            return;
          }
          if (!data.line_items || isEmptyObject(data.line_items)) {
            window.location = '/tickets';
          } else {
            itemsInCart.innerHTML = data.html;
            const cartLink = document.querySelector('.widget.account li.cart a');
            if (cartLink) cartLink.textContent = `View my cart (${data.quantity_in_cart})`;
            if (data.errors && !isEmptyObject(data.errors)) {
              const errDiv = document.createElement('div');
              errDiv.innerHTML = data.errors;
              const toInsert = errDiv.firstElementChild || errDiv;
              ticketInfo.parentNode.insertBefore(toInsert, ticketInfo);
            }
            if (data.notice) {
              const content = document.querySelector('.content');
              if (content) {
                const flash = document.createElement('div');
                flash.className = 'flash';
                flash.innerHTML = `<div class="notice"><p>${data.notice}</p></div>`;
                content.insertBefore(flash, content.firstChild);
              }
            }
            reattachCartListeners();
          }
        });
    }, 400);
  }

  function reattachCartListeners() {
    cart.querySelectorAll('form td.remove a').forEach((a) => {
      a.replaceWith(a.cloneNode(true));
    });
    cart.querySelectorAll('form td.remove a').forEach((a) => {
      a.addEventListener('click', removePackage);
    });
    cart.querySelectorAll('form .add_on a').forEach((a) => {
      a.addEventListener('click', addPackageToCart);
    });
  }

  reattachCartListeners();
}
